import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { Observable, firstValueFrom } from 'rxjs';
import { DialogType, MediDialogComponent } from '../medi-dialog/medi-dialog.component';
import { EventTyp, OroService } from '../oroservice';

@Component({
    selector: 'app-orders',
    templateUrl: './orders.component.html',
    styleUrls: ['./orders.component.scss'],
    standalone: false
})
export class OrdersComponent implements OnInit {
    public get displayedOrderColumns(): string[] {
        const columns = ['Datum', 'Referenz', 'Betrag', 'Standort'];

        if (this.showPractitioner) {
            columns.push('Behandler');
        }

        columns.push('Rechnungsempfaenger', 'Beauftragtam', 'Tools');
        return columns;
    }

    public get showPractitioner(): boolean {
        return this.oroservice.kundeninfo?.BehandlerAbfrage ?? false;
    }

    auftraege: any[] = [];
    currentoption: any;
    isValid: boolean = false;
    isLoading: boolean = false;
    fileToUpload: File = null;
    files: File[] = null;
    kundensettings: any = {};
    showDeleteAuftrag = false;
    search: any = {
        Behandler: -1,
        Standort: -1
    };

    constructor(public oroservice: OroService, private chRef: ChangeDetectorRef, public dialog: MatDialog, private _router: Router) {
        this.oroservice.onChange.subscribe({
            next: (event: EventTyp) => {
                if (event.component === this.constructor.name) {
                    this.oroservice.getKundenInfo();
                    this.refresh();
                }
            }
        })
    }

    ngOnInit() {
        this.isLoading = true;

        this.oroservice.getSettings().then((object) => {
            this.kundensettings = object;
        });
        this.currentoption = this.oroservice.settingscurrent;
        this.oroservice.getAuftraege().then((object) => {
            this.auftraege = object;
            this.isLoading = false;
        });

        this.oroservice.auftragsemitter.subscribe((object) => {
            if (object) {
                this.oroservice.getKundenInfo().then(() => {
                    this.refresh();
                });
            }
        });
    }

    searchClick() {
        if (this.search == null) return;
        this.oroservice.setSearchAuftraege(this.search).then((object) => {
            this.auftraege = object;
        });
    }

    refresh() {
        this.oroservice.getSettings().then((object) => {
            this.kundensettings = object;
        });
        this.currentoption = this.oroservice.settingscurrent;
        this.oroservice.getAuftraege().then((object) => {
            this.auftraege = object;
        });
    }

    ngDoCheck() {
        if (this.currentoption !== this.oroservice.settingscurrent) {
            this.refresh();
        }
    }

    public async selectOrder(order: { Id: number } = { Id: 0 }): Promise<void> {
        if (order.Id === 0 && !await this.oroservice.checkNewOrderAccess()) {
            return;
        }

        await this._router.navigate(['Auftrag', order.Id]);
    }

    public async showDeleteOrderDialog(order: object): Promise<void> {
        const confirmed = await firstValueFrom(this.openDialog("500px", "Aufträge.nachfrageloeschen", "Aufträge.nachfrageloeschenerklaerung", "Aufträge.Löschen", "Abbrechen", DialogType.Question));
        if (!confirmed) {
            return;
        }

        await this.oroservice.deleteAuftrag(order);
        this.refresh();
    }

    openDialog(paramWidth: string, paramTitle: string, paramContent: string, paramYes: string, paramNo: string, paramType: DialogType = DialogType.None): Observable<boolean> {
        const dialogRef = this.dialog.open(MediDialogComponent, {
            width: paramWidth,
            data: { title: paramTitle, content: paramContent, yes: paramYes, no: paramNo, type: paramType }
        });

        return dialogRef.afterClosed();
    }
}
